export const LLM_PATH = '/llm' as const;
export const ROOT = {
  PATH: LLM_PATH,
  toPath: () => LLM_PATH,
};
